import { ConsultProposalResponseDTO } from "@repo/core/services/entities/Proposals";
import {
  formatDateFromISO,
  mapGenderFromString
} from "../hooks/useFidelityProposal/mappers";
import { ReviewFidelityProposalFormattedData } from "./types";

/**
 * Formats phone number from DDD and number parts
 * Returns empty string if either part is missing
 */
const formatPhoneNumber = (ddd?: string, phone?: string): string => {
  if (!ddd || !phone) {
    return "";
  }
  return `${ddd}${phone}`;
};

/**
 * Maps ConsultProposalResponseDTO to ReviewFidelityProposalFormattedData
 * Transforms raw proposal data into formatted display values
 * Uses strProfissaoDescricao from store if available, otherwise falls back to code
 */
export const mapToReviewFidelityProposalData = (
  proposalData?: ConsultProposalResponseDTO & {
    strProfissaoDescricao?: string;
  }
): ReviewFidelityProposalFormattedData => {
  if (!proposalData) {
    return {
      birthday: "",
      martialStatus: "",
      profession: "",
      gender: null,
      name: "",
      cpf: "",
      phone: ""
    };
  }

  // Use stored profession description if available, otherwise use code
  const professionDisplay =
    proposalData.strProfissaoDescricao || proposalData.strProfissao || "";

  return {
    birthday: formatDateFromISO(proposalData.datDataNascimento),
    martialStatus: proposalData.strEstadoCivil || "",
    profession: professionDisplay,
    gender: mapGenderFromString(proposalData.strSexo),
    name: proposalData.strNome || "",
    cpf: proposalData.strCpf || "",
    phone: formatPhoneNumber(
      proposalData.strCelularDDD,
      proposalData.strCelular
    )
  };
};
